import { lazy } from "react";
import { Navigate } from "react-router-dom";

const ProfileEdit = lazy(() => import("../components/profileEdit"));
const ProfileView = lazy(() => import("../components/profileView"));

const profileRoute = {
  name: "Profile",
  link: "/profile",
  path: "profile",
  element: "",
  superAdminView: false,
  children: [
    {
      path: "view",
      element: <ProfileView />,
    },
    {
      path: "edit",
      element: <ProfileEdit />,
    },
    // {

    //   path: "profile/:id",
    //   link: "profile/:id",
    //   element: <ProfileEdit />,
    // },
    {
      path: "",
      element: <Navigate to="dashboard" replace />,
    },
  ],
};
export default profileRoute;
